export const USER_LOAD_REQUEST = 'USER_LOAD_REQUEST';
export const USER_CREATE_REQUEST = 'USER_CREATE_REQUEST';
export const USER_LOAD_SUCCESS = 'USER_LOAD_SUCCESS';
export const USER_LOAD_FAILURE = 'USER_LOAD_FAILURE';
export const USER_REFRESH_REQUEST = 'USER_REFRESH_REQUEST';
